import { FALL_RISK, type FallRisk } from "@packages/core";
import React, { useMemo } from "react";
import { FaFrown, FaSmile, FaTired } from "react-icons/fa";
import { Merge } from "type-fest";

import { fromFallRiskToColor, useTranslate } from "../../services";
import { css, cx } from "../../styled-system/css";
import { TypographyStyle } from "../common";

export type FallRiskDisplayProperties = Merge<
  React.ComponentProps<"div">,
  {
    fallRisk?: FallRisk | false | null | undefined;
  }
>;

export function FallRiskDisplay({ className, fallRisk, ...properties }: FallRiskDisplayProperties) {
  const translate = useTranslate();

  const { color, icon, text } = useMemo(
    function () {
      let color, icon;
      switch (fallRisk) {
        case FALL_RISK.MILD:
          color = fromFallRiskToColor(FALL_RISK.MILD);
          icon = <FaSmile />;
          break;
        case FALL_RISK.MODERATE:
          color = fromFallRiskToColor(FALL_RISK.MODERATE);
          icon = <FaFrown />;
          break;
        case FALL_RISK.SEVERE:
          color = fromFallRiskToColor(FALL_RISK.SEVERE);
          icon = <FaTired />;
          break;
        default:
          color = "black";
          icon = null;
          break;
      }

      return { color, icon, text: fallRisk ? translate("%FallRisk." + fallRisk + ".0%") : "-" };
    },
    [fallRisk, translate],
  );

  return (
    <div
      {...properties}
      className={cx(
        css(
          TypographyStyle.raw({ ellipsis: true, fontSize: "24px", fontWeight: 700, lineHeight: 1 }),
          { alignItems: "center", display: "flex", gap: "2px" },
        ),
        className,
      )}
      style={{ color }}
    >
      {icon}
      <span>{text}</span>
    </div>
  );
}
